import { ApiService } from "../_services";

const getHandouts = () => {
  const client = new ApiService();
  const path = `/handouts?limit=100`;

  client.setAuthHeader();
  return client.get(path)
    .then(response => {
      if (!response) {
        console.log("error fetching handouts")
        return {};
      }
      const data = response.data || {};
      return data;
    });
};

export const handoutsService = {
  getHandouts
};